import { render, staticRenderFns } from "./addedit-project.vue?vue&type=template&id=70ba44ba&scoped=true"
import script from "./addedit-project.vue?vue&type=script&lang=js"
export * from "./addedit-project.vue?vue&type=script&lang=js"
import style0 from "./addedit-project.vue?vue&type=style&index=0&id=70ba44ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba44ba",
  null
  
)

export default component.exports